/**
 * Sidebar display mode — expanded (200px) | compact (48px icon rail) | hidden (0px).
 */
import { kvGetRaw, kvSetRaw } from '../infrastructure/storage/kvAccess';

export const SIDEBAR_MODES = ['expanded', 'compact', 'hidden'];

const APP_SIDEBAR_MODE_KEY = 'aman_app_sidebar_mode';
const LEGACY_SIDEBAR_HIDDEN_KEY = 'aman_app_sidebar_hidden';
const LEGACY_MANAGER_HIDDEN_KEY = 'aman_manager_sidebar_hidden';

export function readSidebarMode() {
  try {
    const stored = kvGetRaw(APP_SIDEBAR_MODE_KEY);
    if (SIDEBAR_MODES.includes(stored)) return stored;
    if (kvGetRaw(LEGACY_SIDEBAR_HIDDEN_KEY) === '1') return 'hidden';
    if (kvGetRaw(LEGACY_MANAGER_HIDDEN_KEY) === '1') return 'hidden';
    return 'compact';
  } catch {
    return 'compact';
  }
}

export function writeSidebarMode(mode) {
  if (!SIDEBAR_MODES.includes(mode)) return;
  try {
    kvSetRaw(APP_SIDEBAR_MODE_KEY, mode);
    kvSetRaw(LEGACY_SIDEBAR_HIDDEN_KEY, mode === 'hidden' ? '1' : '0');
  } catch {
    /* ignore quota */
  }
}

/** Desktop toggle: expanded → compact → hidden → expanded */
export function cycleSidebarMode(current) {
  if (current === 'expanded') return 'compact';
  if (current === 'compact') return 'hidden';
  return 'expanded';
}
